export enum MyMaskReturningPath {
  dashboard = 'dashboard',
  myaccount = 'my-account',
  library = 'library',
}
